import React, { useState, useEffect } from 'react';
import { Button } from '../../../../components/ui/button';
import { YoolTable, StatusPill, RowActions, IconButton } from '../../../../components/ui/YoolTable';
import { EmptyState } from '../../../../components/ui/empty-state';
import { getPlans, syncPlanWithFileMaker } from '../../../../services/virtualPosService';
import formatters from '../../../../styles/tokens/formatters';
import { Plus, Wallet, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const VirtualPosPlansList = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadPlans();
  }, []);

  const loadPlans = async () => {
    try {
      setLoading(true);
      const response = await getPlans();
      setPlans(response.plans || []);
    } catch (error) {
      console.error('Error al cargar planes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSyncAll = async () => {
    try {
      setSyncing(true);
      for (const plan of plans) {
        await syncPlanWithFileMaker(plan);
      }
      alert('Sincronización completada');
    } catch (error) {
      console.error('Error en sincronización:', error);
      alert('Error en la sincronización');
    } finally {
      setSyncing(false);
    }
  };

  const columns = [
    {
      key: 'name',
      label: 'Nombre',
      render: (r) => (
        <div className="flex items-center space-x-2">
          <Wallet className="h-4 w-4 text-muted-foreground" />
          <span className="font-medium">{r.name}</span>
        </div>
      ),
    },
    {
      key: 'amount',
      label: 'Monto',
      render: (r) => r.currency === 'CLP' ? formatters.formatCLP(r.amount) : `${r.amount} UF`,
    },
    {
      key: 'frequency_type',
      label: 'Frecuencia',
    },
    {
      key: 'is_active',
      label: 'Estado',
      render: (r) => <StatusPill estado={r.is_active === 'T' ? 'activo' : 'inactivo'} />,
    },
    {
      key: 'actions',
      label: 'Acciones',
      render: (r) => (
        <RowActions>
          <IconButton
            icon="eye"
            label="Ver"
            onClick={() => navigate(`/payments-admin/virtualpos/planes/${r.id}`)}
          />
        </RowActions>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Planes VirtualPos</h1>
          <p className="text-muted-foreground">
            Gestiona los planes de suscripción de VirtualPos
          </p>
        </div>
        <div className="flex space-x-2">
          <Button
            onClick={handleSyncAll}
            disabled={syncing}
            variant="outline"
          >
            <RefreshCw className={`h-4 w-4 mr-2 ${syncing ? 'animate-spin' : ''}`} />
            {syncing ? 'Sincronizando...' : 'Sincronizar con FileMaker'}
          </Button>
          <Button onClick={() => navigate('/payments-admin/virtualpos/planes/new')}>
            <Plus className="h-4 w-4 mr-2" />
            Crear Plan
          </Button>
        </div>
      </div>

      <YoolTable
        rows={plans}
        columns={columns}
        search={{ placeholder: 'Buscar planes por nombre…', keys: ['name'] }}
        toolbar={
          <span className="text-sm font-semibold text-foreground">
            Planes <span className="font-normal text-muted-foreground">({plans.length})</span>
          </span>
        }
        empty={
          <EmptyState
            icon={<Wallet />}
            title="Sin planes VirtualPos"
            description="No hay planes de suscripción configurados aún. Crea el primero para empezar."
            action={{ label: 'Crear plan', onClick: () => navigate('/payments-admin/virtualpos/planes/new') }}
          />
        }
      />
    </div>
  );
};

export default VirtualPosPlansList;